import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument.js";
import { auth, dbCentral } from "../../config/FirebaseConfig.js";

const uploadProfilePictureFromBlob = async (uid, blob, token, prefix) => {
  try {
    if (!blob) {
      console.error("No blob provided");
      return;
    }

    const fetchBlobFromURL = async (url) => {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch the image");
      return await response.blob();
    };

    // Process the image blob
    const processImage = async (input) => {
      const blob =
        typeof input === "string" ? await fetchBlobFromURL(input) : input;
      if (!(blob instanceof Blob)) {
        throw new Error("Input is not a valid Blob");
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const maxWidth = 800;
            const maxHeight = 800;
            let width = img.width;
            let height = img.height;

            if (width > maxWidth || height > maxHeight) {
              if (width > height) {
                height = Math.round((height * maxWidth) / width);
                width = maxWidth;
              } else {
                width = Math.round((width * maxHeight) / height);
                height = maxHeight;
              }
            }

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
              (compressedBlob) => resolve(compressedBlob),
              "image/jpeg",
              0.5
            );
          };
          img.onerror = (err) => reject(err);
          img.src = event.target.result;
        };
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(blob);
      });
    };

    // Compress the provided blob
    const compressedImage = await processImage(blob);

    const url = prefix + "upload/profile-picture";
    const fileName = "profile_picture.jpg";

    if (compressedImage) {
      const formData = new FormData();
      formData.append("file", compressedImage, fileName);
      formData.append("uid", uid);

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      let start = new Date();
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: formData,
      });

      const currentUser = auth.currentUser;
      if (!currentUser) {
        console.error("User not logged in");
        return;
      }

      const userRef = doc(dbCentral, "user", currentUser.uid);
      const userSnapshot = await getDoc(userRef);

      if (!userSnapshot.exists()) {
        console.error("User document not found");
        return;
      }

      const orgId = userSnapshot.get("org_id");
      let end = new Date();
      let elapsed = end - start;

      // Add log document
      await addLogDocument(
        url,
        prefix,
        userRef.id,
        orgId,
        response.status.toString(),
        "",
        "",
        formData.toString(),
        await response.text(),
        "POST",
        elapsed
      );

      if (!response.ok) {
        console.error(`Error response: ${response.status}`);
      }
    }
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};

export default uploadProfilePictureFromBlob;
